import { Box, Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { makeStyles } from 'tss-react/mui';


export const useProviderAvatarStyles = makeStyles()(theme => ({
  date: {
    color: theme.palette.text.primary,
    fontWeight: 700
  },
  image: {
    display: 'block',
    height: '72px',
    width: '72px',
    [theme.breakpoints.up('sm')]: {
      height: '180px',
      width: '180px',
    }
  },
  nextAvailable: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      backgroundColor: theme.palette.primaryBackground.main,
      display: 'block',
      padding: theme.spacing(1),
      textAlign: 'center',
    }
  },
  root: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      width: '180px',
    }
  }
}));


export type MatchingAvatarProps = {
  avatarUrl?: string;
  nextAvailableDate?: string;
};


export const MatchingAvatar: React.VFC<MatchingAvatarProps> = props => {
  const { classes } = useProviderAvatarStyles();
  const l10n = useL10n();

  return (
    <Box className={classes.root}>
      <img src={props.avatarUrl} alt="avatar" className={classes.image} />
      <Box className={classes.nextAvailable}>
        <Typography variant="caption" color="textSecondary">
          {l10n.matching.providers.nextAvailable}
        </Typography>
        <Box className={classes.date}>
          {props.nextAvailableDate}
        </Box>
      </Box>
    </Box>
  );
};
